function nextCopySlug(slug, existingSlugs) {
  const base = `${slug || 'pattern'}-copy`;
  if (!existingSlugs.includes(base)) return base;

  let suffix = 2;
  while (existingSlugs.includes(`${base}-${suffix}`)) suffix += 1;
  return `${base}-${suffix}`;
}

export function preparePatternDuplicate(pattern, existingSlugs = []) {
  const copy = { ...pattern };
  delete copy.id;
  delete copy.created_at;
  delete copy.updated_at;

  return {
    ...copy,
    title: `${pattern.title || 'Untitled pattern'} (Copy)`,
    slug: nextCopySlug(pattern.slug, existingSlugs),
    status: 'draft',
  };
}
